import { IFilter, IRootState } from '@/store/types/IRootState';
import FilterServiceBase from '@/services/FilterServiceBase';

const companyFilterGetters = {
    getNCompanyFilters: (state: IRootState) => (numberFiltersToShow: number): IFilter[] => {
        return FilterServiceBase.getters.getNFilters(
            state.companyFilters.filters,
            numberFiltersToShow,
            state.companyFilters.showAllFilters);
    },
    getNumberOfRemainingCompanyFilters: (state: IRootState) => (numberFiltersToShow: number): number => {
        return FilterServiceBase.getters.getNumberOfRemainingFilters(
            state.companyFilters.filters,
            numberFiltersToShow);
    },
    getCheckedCompanyFilters: (state: IRootState): IFilter[] => {
        return FilterServiceBase.getters.getCheckedFilters(
            state.companyFilters.filters);
    },
    getShowAllCompanyFilters: (state: IRootState): boolean => {
        return state.companyFilters.showAllFilters;
    },
    getCompanyFiltersLength: (state: IRootState): number => {
        return state.companyFilters.filters.length;
    },
    hasCompanyFilters(state: IRootState): boolean {
        return FilterServiceBase.getters.hasFilters(state.companyFilters.filters);
    },
    getShowFilterGroupCompanyFilters: (state: IRootState): boolean => {
        return state.companyFilters.showFilterGroup;
    },
    displayCompanyFilter: (state: IRootState): boolean => {
        return !(state.companyFilters.filters.length === 1 && state.companyFilters.filters[0].count === state.itemsCounter);
    },
};
export default companyFilterGetters;
